import React from 'react';
import casticartLogo from '../../../assets/branding/casticart_logo.svg';
import { BANK_ACCOUNT_TYPE_OPTIONS } from './artistOnboardingGateUtils';
import DsSelect from '../../common/DsSelect';

export const BrandLogo = () => (
  <div className="artist-onboarding-gate__brand">
    <img src={casticartLogo} alt="Casticart" />
  </div>
);

export function BankInfoStep({
  visibleStepIndex,
  visibleStepMeta,
  bankForm,
  setBankForm,
  runAction,
  saveBankInfo,
  working,
  goToPreviousStep,
  previousStepKey,
}) {
  return (
    <section className="artist-onboarding-gate__step">
      <div className="artist-onboarding-gate__step-heading">
        <p>STEP {visibleStepIndex + 1}</p>
        <h1>{visibleStepMeta.title}</h1>
        <span>{visibleStepMeta.description}</span>
      </div>

      <div className="artist-onboarding-gate__card artist-onboarding-gate__block-list">
        <div className="artist-onboarding-gate__form artist-onboarding-gate__form-grid">
          <div className="artist-onboarding-gate__subsection artist-onboarding-gate__wide">
            <div className="artist-onboarding-gate__subsection-heading">
              <h2>振込先口座</h2>
              <p>報酬を受け取る銀行口座を登録します。</p>
            </div>
            <div className="artist-onboarding-gate__inner-grid">
              <label>
                <span>銀行名 <b>*</b></span>
                <input
                  value={bankForm.bank_name}
                  onChange={(event) =>
                    setBankForm((prev) => ({ ...prev, bank_name: event.target.value }))
                  }
                  placeholder="例：みずほ銀行"
                />
              </label>
              <label>
                <span>金融機関コード <b>*</b></span>
                <input
                  value={bankForm.bank_code}
                  inputMode="numeric"
                  onChange={(event) =>
                    setBankForm((prev) => ({ ...prev, bank_code: event.target.value }))
                  }
                  placeholder="例：0001"
                />
              </label>
              <label>
                <span>支店名 <b>*</b></span>
                <input
                  value={bankForm.branch_name}
                  onChange={(event) =>
                    setBankForm((prev) => ({ ...prev, branch_name: event.target.value }))
                  }
                  placeholder="例：渋谷支店"
                />
              </label>
              <label>
                <span>支店コード <b>*</b></span>
                <input
                  value={bankForm.branch_code}
                  inputMode="numeric"
                  onChange={(event) =>
                    setBankForm((prev) => ({ ...prev, branch_code: event.target.value }))
                  }
                  placeholder="例：123"
                />
              </label>
              <label>
                <span>口座種別 <b>*</b></span>
                <DsSelect
                  value={bankForm.account_type}
                  onChange={(event) =>
                    setBankForm((prev) => ({ ...prev, account_type: event.target.value }))
                  }
                >
                  <option value="">選択してください</option>
                  {BANK_ACCOUNT_TYPE_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </DsSelect>
              </label>
              <label>
                <span>口座番号 <b>*</b></span>
                <input
                  value={bankForm.account_number}
                  inputMode="numeric"
                  maxLength={7}
                  onChange={(event) =>
                    setBankForm((prev) => ({ ...prev, account_number: event.target.value }))
                  }
                  placeholder="7桁の半角数字"
                />
              </label>
              <label className="artist-onboarding-gate__wide">
                <span>口座名義（カナ） <b>*</b></span>
                <input
                  value={bankForm.account_name}
                  onChange={(event) =>
                    setBankForm((prev) => ({ ...prev, account_name: event.target.value }))
                  }
                  placeholder="例：キャスティ タロウ"
                />
              </label>
            </div>
          </div>
          <div className="artist-onboarding-gate__subsection artist-onboarding-gate__wide">
            <div className="artist-onboarding-gate__subsection-heading">
              <h2>インボイス情報</h2>
              <p>適格請求書発行事業者として登録済みの場合は設定してください。</p>
            </div>
            <label className="artist-onboarding-gate__toggle-row">
              <span>
                <strong>インボイス登録事業者</strong>
                <small>登録済みの場合はオンにしてください</small>
              </span>
              <input
                type="checkbox"
                checked={Boolean(bankForm.invoice_registered)}
                onChange={(event) =>
                  setBankForm((prev) => ({
                    ...prev,
                    invoice_registered: event.target.checked,
                  }))
                }
              />
            </label>

            {bankForm.invoice_registered ? (
              <div className="artist-onboarding-gate__inner-grid">
                <label>
                  <span>インボイス事業者名 <b>*</b></span>
                  <input
                    value={bankForm.invoice_company}
                    onChange={(event) =>
                      setBankForm((prev) => ({
                        ...prev,
                        invoice_company: event.target.value,
                      }))
                    }
                    placeholder="法人名／屋号"
                  />
                </label>
                <label>
                  <span>インボイス登録番号 <b>*</b></span>
                  <input
                    value={bankForm.invoice_number}
                    onChange={(event) =>
                      setBankForm((prev) => ({
                        ...prev,
                        invoice_number: event.target.value,
                      }))
                    }
                    placeholder="T1234567890123"
                  />
                </label>
              </div>
            ) : null}
          </div>

          <div className="artist-onboarding-gate__subsection artist-onboarding-gate__wide">
            <div className="artist-onboarding-gate__subsection-heading">
              <h2>請求元情報（請求書表示用）</h2>
              <p>プロフィール情報をそのまま使うか、請求書表示専用に再設定するかを選べます。</p>
            </div>
            <div
              className="artist-onboarding-gate__choice-group"
              role="radiogroup"
              aria-label="請求元の表示方法"
            >
              <button
                type="button"
                className={`artist-onboarding-gate__choice ${
                  bankForm.invoice_sender_mode !== 'custom' ? 'is-selected' : ''
                }`}
                onClick={() =>
                  setBankForm((prev) => ({
                    ...prev,
                    invoice_sender_mode: 'profile',
                  }))
                }
                aria-pressed={bankForm.invoice_sender_mode !== 'custom'}
              >
                <strong>プロフィール情報を使う</strong>
                <small>氏名・会社名・連絡先はプロフィールの登録内容をそのまま請求書へ掲載します。</small>
              </button>
              <button
                type="button"
                className={`artist-onboarding-gate__choice ${
                  bankForm.invoice_sender_mode === 'custom' ? 'is-selected' : ''
                }`}
                onClick={() =>
                  setBankForm((prev) => ({
                    ...prev,
                    invoice_sender_mode: 'custom',
                  }))
                }
                aria-pressed={bankForm.invoice_sender_mode === 'custom'}
              >
                <strong>請求書表示専用に設定する</strong>
                <small>請求元名・連絡先を請求書用に設定します。プロフィール情報へはフォールバックしません。</small>
              </button>
            </div>

            {bankForm.invoice_sender_mode === 'custom' ? (
              <>
                <label className="artist-onboarding-gate__toggle-row">
                  <span>
                    <strong>請求元会社名 / 屋号は掲載しない</strong>
                    <small>請求元名だけを表示したい場合に使用します。</small>
                  </span>
                  <input
                    type="checkbox"
                    checked={Boolean(bankForm.invoice_sender_hide_company_name)}
                    onChange={(event) =>
                      setBankForm((prev) => ({
                        ...prev,
                        invoice_sender_hide_company_name: event.target.checked,
                      }))
                    }
                  />
                </label>
                <div className="artist-onboarding-gate__inner-grid">
                  <label>
                    <span>請求元名</span>
                    <input
                      value={bankForm.invoice_sender_name}
                      onChange={(event) =>
                        setBankForm((prev) => ({
                          ...prev,
                          invoice_sender_name: event.target.value,
                        }))
                      }
                      placeholder="請求書に表示する氏名または名称"
                    />
                  </label>
                  <label>
                    <span>請求元会社名 / 屋号</span>
                    <input
                      value={bankForm.invoice_sender_company_name}
                      onChange={(event) =>
                        setBankForm((prev) => ({
                          ...prev,
                          invoice_sender_company_name: event.target.value,
                        }))
                      }
                      placeholder="請求書に表示する会社名 / 屋号"
                      disabled={Boolean(bankForm.invoice_sender_hide_company_name)}
                    />
                  </label>
                  <label>
                    <span>請求元メールアドレス</span>
                    <input
                      type="email"
                      value={bankForm.invoice_sender_email}
                      onChange={(event) =>
                        setBankForm((prev) => ({
                          ...prev,
                          invoice_sender_email: event.target.value,
                        }))
                      }
                      placeholder="billing@example.com"
                    />
                  </label>
                  <label>
                    <span>請求元電話番号</span>
                    <input
                      value={bankForm.invoice_sender_phone}
                      onChange={(event) =>
                        setBankForm((prev) => ({
                          ...prev,
                          invoice_sender_phone: event.target.value,
                        }))
                      }
                      placeholder="請求書に表示する電話番号"
                    />
                  </label>
                </div>
              </>
            ) : null}
          </div>
        </div>
        <div className="artist-onboarding-gate__footer">
          <button
            type="button"
            className="artist-onboarding-gate__primary"
            onClick={() => runAction(saveBankInfo)}
            disabled={working}
          >
            次へ
          </button>
          <button
            type="button"
            className="artist-onboarding-gate__back"
            onClick={goToPreviousStep}
            disabled={working || !previousStepKey}
          >
            戻る
          </button>
        </div>
      </div>
    </section>
  );
}
